<template>
<div>
  <v-layout row wrap justify-space-between>
    <v-flex xs3>
      <v-text-field
        class="search-input-component"
        append-icon="search"
        label="Search by receiver email"
        v-model="search.receiverEmail"
      />
    </v-flex>
    <v-flex xs3>
      <v-text-field
        class="search-input-component"
        append-icon="search"
        label="Search by invitation name"
        v-model="search.invitationName"
      />
    </v-flex>
    <v-flex xs3>
      <v-text-field
      class="search-input-component"
      append-icon="search"
      label="Search by invitation id"
      v-model="search.invitationId"
    />
    </v-flex>
  </v-layout>
  <div class="data-table-wrapper">
    <v-data-table
      :headers="headers"
      :items="getVipInvitations"
      :pagination.sync="pagination"
      class="data-table"
      :total-items="totalItemsInTable"
    >
      <template slot="items" slot-scope="props">
        <td class="py-4">{{ props.item.slug }}</td>
        <td class="py-4">{{ props.item.code }}</td>
        <td class="py-4">{{ props.item.receiverEmail }}</td>
        <td class="py-4">{{ props.item.invitationName }}</td>
        <td class="py-4">{{ props.item.vipAttendeeTypeName }}</td>
        <td class="py-4">{{ props.item.vipInvitationType }}</td>
        <td class="py-4">{{ props.item.status }}</td>
        <td class="py-4">{{ props.item.ticketsCount }}</td>
        <td class="py-4">{{ props.item.usedCount }}</td>
        <td class="py-4">{{ props.item.paymentType }}</td>
        <td class="py-4">{{displayPaymentMethod(props.item.paymentProviders)}}</td>
        <td class="py-4">{{ props.item.paymentStatus}}</td>
        <td class="text-xs-center">
          <v-tooltip bottom :disabled="isInvitationEnabled(props.item)">
            <v-btn
              color="lime"
              fab flat
              slot="activator"
              @click.stop="enableInvitation(props.item)"
              :disabled="isInvitationEnabled(props.item)"
            >
              <v-icon>add</v-icon>
            </v-btn>
            <span>Enable invitation</span>
          </v-tooltip>
        </td>
        <td class="text-xs-center">
          <v-tooltip bottom :disabled="!isInvitationEnabled(props.item)">
            <v-btn
              color="red"
              fab flat
              slot="activator"
              @click.stop="disableInvitation(props.item.id)"
              :disabled="!isInvitationEnabled(props.item)"
            >
              <v-icon>clear</v-icon>
            </v-btn>
            <span>Disable invitation</span>
          </v-tooltip>
        </td>
        <td class="text-xs-center">
          <v-tooltip bottom :disabled="isInvitationEnabled(props.item)">
            <v-btn
              color="blue darken-1"
              fab flat
              slot="activator"
              @click.stop="showResendInvitationDialog(props.item)"
            >
              <v-icon>email</v-icon>
            </v-btn>
            <span>Enable invitation</span>
          </v-tooltip>
        </td>
        <td class="text-xs-center">
          <v-tooltip bottom>
            <v-btn
              color="lime"
              fab flat
              slot="activator"
              @click.stop="editInvitation(props.item)"
            >
              <v-icon>create</v-icon>
            </v-btn>
            <span>Edit invitation</span>
          </v-tooltip>
        </td>
        <td class="text-xs-center">
          <v-tooltip bottom>
            <v-btn
              color="lime"
              fab flat
              slot="activator"
              @click="editInvitationPackage(props.item.packageId, props.item)"
            >
              <v-icon>create</v-icon>
            </v-btn>
            <span>Edit package</span>
          </v-tooltip>
        </td>
        <td class="text-xs-center">
          <v-tooltip bottom>
            <v-btn
              color="blue"
              fab flat
              slot="activator"
              @click.stop="showUpdateData(props.item)"
            >
              <v-icon>restore</v-icon>
            </v-btn>
            <span>Update data</span>
          </v-tooltip>
        </td>
      </template>
    </v-data-table>
  </div>
  <v-dialog
    persistent
    v-model="isEditInvitationFormVisible"
    transition="dialog-bottom-transition"
    fullscreen
    persistent
    hide-overlay
    scrollable
  >
    <edit-invitation-form
      :item="editingInvitation"
      @close="closeForms"
      @edit="getFilteredVipInvitation"
    />
  </v-dialog>
  <v-dialog
    persistent
    v-if="editingInvitation"
    v-model="isEditInvitationPackageFormVisible"
    transition="dialog-bottom-transition"
    fullscreen
    persistent
    hide-overlay
    scrollable
  >
    <edit-invitation-pakage-form
      :item="getVipInvitationPackage"
      :invitation="editingInvitation"
      @close="closeForms"
    />
  </v-dialog>
  <v-dialog
    persistent
    v-model="isEnableInvitationFormVisible"
    persistent
    max-width="500"
  >
    <enable-invitation-form
      :params="compareParams"
      :item="invitationForEnabling"
      :isOpen="isEnableInvitationFormVisible"
      @close="closeForms"
    />
  </v-dialog>
  <v-dialog
    persistent
    v-model="isResendInvitationModalVisible"
    persistent
    max-width="600"
    persistent
  >
    <v-card class="pa-4">
      <h3>
        Email template for repeated invitation
      </h3>
      <v-layout row>
        <v-flex xs7>
          <v-select
            single-line
            :items="vipInvitationTemplatesList"
            v-model="resendInvitationData.templateKey"
            label="Select email template"
            item-text="templateKey"
            item-value="templateKey"
            required
          ></v-select>
        </v-flex>
      </v-layout>
      <v-btn color="info" @click.stop="resendVipAttendeeInvitation">Resend Invitation</v-btn>
    </v-card>
  </v-dialog>
  <v-dialog
    persistent
    max-width="500"
    persistent
    v-model="isUpdateDataVisible"
    transition="dialog-bottom-transition">
    <v-card>
      <v-card-text>
        <v-container>
          <v-layout column>
            <h3 class="text-xs-center py-2 my-2">
              VIP invitation update data
            </h3>
            <p><strong>Creation Date:</strong> {{updateData.creationDate}}</p>
            <p><strong>Update Date:</strong> {{updateData.updateDate}}</p>
            <p><strong>Last Updater Name:</strong> {{updateData.lastUpdaterName}}</p>
            <p><strong>Creator name:</strong> {{updateData.creatorName}}</p>
            <v-flex flex-end>

            </v-flex>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                flat="flat"
                @click="closeUpdateDataDialog()"
              >
                close
              </v-btn>
            </v-card-actions>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import EditInvitationForm from './editInvitationForm'
import EditInvitationPakageForm from './editInvitationPackageForm'
import EnableInvitationForm from './enableInvitationForm'
import mixins from '@/utils/mixins'
import { timeSettings } from '@/modules/settings/'
import { clone, equals, pathOr, isNil } from 'ramda'
import debounce from 'lodash.debounce'

const updateTableTriggers = ['editInvitation']

export default {
  name: 'VipInvitations',
  mixins: [mixins.emailTemplates],
  components: {
    EditInvitationForm,
    EditInvitationPakageForm,
    EnableInvitationForm
  },
  data () {
    return {
      resendInvitationData: {
        id: '',
        templateKey: ''
      },
      isResendInvitationModalVisible: false,
      isEditInvitationFormVisible: false,
      isEditInvitationPackageFormVisible: false,
      isEnableInvitationFormVisible: false,
      editingInvitation: {},
      invitationForEnabling: {},
      totalItems: 5,
      pagination: {
        rowsPerPage: 5,
        sortBy: 'CreationDate',
        descending: true
      },
      headers: [
        { text: 'Slug', value: 'slug', search: true, sortable: false, width: 50 },
        { text: 'Code', value: 'code', search: true, sortable: true, width: 50 },
        { text: 'Receiver Email', value: 'receiverEmail', search: true, sortable: true },
        { text: 'Invitation Name', value: 'invitationName', search: true, sortable: true },
        { text: 'Vip attendee type', value: 'vipAttendeeTypeName', sortable: true, width: 100 },
        { text: 'Invitation type', value: 'vipInvitationType', sortable: true, width: 50 },
        { text: 'Status', value: 'status', width: 50 },
        { text: 'Tickets count', value: 'ticketsCount', sortable: true, width: 50 },
        { text: 'Used count', value: 'usedCount', sortable: false, width: 50 },
        { text: 'Payment type', value: 'paymentType', search: true, sortable: false, width: 50 },
        { text: 'Payment method', value: 'paymentProviders', search: false, sortable: false, width: 50 },
        { text: 'Payment status', value: 'paymentStatus', search: false, sortable: false, width: 50 },
        { text: 'Enable invitation', sortable: false, align: 'center', width: 50 },
        { text: 'Disable invitation', sortable: false, align: 'center', width: 50 },
        { text: 'Resend invitation', sortable: false, align: 'center', width: 50 },
        { text: 'Edit invitation', sortable: false, align: 'center', width: 50 },
        { text: 'Edit package', sortable: false, align: 'center', width: 50 },
        { text: 'Update data', sortable: false, align: 'center', width: 50 }
      ],
      isUpdateDataVisible: false,
      updateData: {
        creationDate: '',
        updateDate: '',
        lastUpdaterName: '',
        creatorName: ''
      },
      search: {
        receiverEmail: '',
        invitationName: '',
        invitationId: ''
      },
      compareParams: null
    }
  },
  computed: {
    ...mapGetters([
      'getVipInvitations',
      'getTotalVipInvitationsItems',
      'getVipInvitationPackage',
      'getTotalVipInvitationsPages'
    ]),
    totalItemsInTable () {
      return this.getTotalVipInvitationsItems || (this.getTotalVipInvitationsPages * this.pagination.rowsPerPage)
    }
  },
  watch: {
    pagination: {
      handler () {
        this.getFilteredVipInvitation()
      },
      deep: true
    },
    search: {
      handler () {
        this.getFilteredVipInvitation()
      },
      deep: true
    }
  },
  methods: {
    ...mapActions([
      'fetchVipInvitations',
      'fetchVipInvitationPackage',
      'disableVipInvitationPackage',
      'resendVipInvitation',
      'showResultErrorMessage'
    ]),
    editInvitation (invitation) {
      this.editingInvitation = invitation
      this.isEditInvitationFormVisible = true
    },
    transformDate (date) {
      const d = new Date(date)
      const month = d.getMonth() + 1
      const day = d.getDate()
      const year = d.getUTCFullYear()
      return `${month} / ${day} / ${year}`
    },
    resendVipAttendeeInvitation () {
      this.resendVipInvitation(this.resendInvitationData)
    },
    async editInvitationPackage (packageId, invitation) {
      await this.fetchVipInvitationPackage(packageId)
      this.editingInvitation = invitation
      this.isEditInvitationPackageFormVisible = true
    },
    enableInvitation (invitation) {
      this.invitationForEnabling = clone({
        id: invitation.id,
        ticketsCount: invitation.ticketsCount
      })
      this.isEnableInvitationFormVisible = true
    },
    async disableInvitation (invitationId) {
      try {
        const param = !isNil(this.compareParams) ? this.compareParams : {itemsOnPage: this.totalItems}
        await this.disableVipInvitationPackage({ id: invitationId })
        await this.fetchVipInvitations(param)
      } catch (err) {
        console.error(err)
      }
    },
    closeForms () {
      this.isEditInvitationFormVisible = false
      this.isEditInvitationPackageFormVisible = false
      this.isEnableInvitationFormVisible = false
    },
    isInvitationEnabled (invitation) {
      return invitation.status === 'Enabled'
    },
    displayPaymentMethod (methodsArr) {
      if (methodsArr.length > 1) {
        return 'Both'
      } else if (methodsArr.length === 1) {
        return methodsArr[0] === '1' ? 'PayPal' : 'BlueSnap'
      } else {
        return
      }
    },
    showResendInvitationDialog (invitation) {
      this.isResendInvitationModalVisible = true
      this.resendInvitationData.id = invitation.id
    },
    showUpdateData (data) {
      this.isUpdateDataVisible = true
      this.updateData.creationDate = this.transformDate(data.creationDate)
      this.updateData.updateDate = this.transformDate(data.updateDate)
      this.updateData.lastUpdaterName = data.lastUpdaterName
      this.updateData.creatorName = data.creatorName
    },
    closeUpdateDataDialog () {
      this.isUpdateDataVisible = false
    },
    getFilteredVipInvitation: debounce(async function (reloadTrigger) {
      this.loading = true
      const { sortBy, descending, page, rowsPerPage } = this.pagination
      let itemsOnPage = equals(rowsPerPage, -1) ? this.totalItemsInTable : rowsPerPage
      const sort = descending ? 'Desc' : 'Asc'
      const name = sortBy ? sortBy[0].toUpperCase() + sortBy.slice(1) : null
      const newPage = page - 1
      const pageCheck = newPage > 0 ? newPage : 0
      const getParams = {
        page: pageCheck,
        itemsOnPage,
        filter: {
          receiverEmail: pathOr('', ['receiverEmail'], this.search),
          invitationName: pathOr('', ['invitationName'], this.search),
          invitationId: pathOr('', ['invitationId'], this.search)
        },
        rowsPerPage,
        sort,
        name
      }
      try {
        await this.fetchVipInvitationIfExpediency(getParams, this.compareParams, reloadTrigger)
      } catch (err) {
        this.showResultErrorMessage('Error during fetching vip invitations')
      }
      this.loading = false
      this.compareParams = getParams
    }, timeSettings.delayTime),
    async fetchVipInvitationIfExpediency (currentParams, oldParams, reloadTrigger) {
      const paramsChanged = !equals(currentParams, oldParams)
      const updateByTrigger = updateTableTriggers.includes(reloadTrigger)
      if (paramsChanged || updateByTrigger) {
        try {
          await this.fetchVipInvitations(currentParams)
        } catch (err) {
          throw err
        } finally {
          this.loading = false
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .data-table-wrapper {
    width: calc(100vw - 310px);

    @media screen and (max-width: 1263px) {
      width: calc(100vw - 100px);
    }
  }

  .data-table {
    width: 100%;
    overflow-x: auto;
  }

  .search-input-component {
    margin-right: 16px;

    &:last-child {
      margin-right: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/Registration/Attendee/VipInvitation/index.vue